import { view } from "@/mega-ui/helpers/function"
import { getAuthenticationStore } from "@/helpers/storeHelpers"

export const offers = {
    path: '/offers',
    name: 'offers',
    children: [
        {
            path: 'main',
            name: 'offers-main',
            meta: {
                withAuth: true,
            },
            component: () => view('offers/MegaAvantagesMainView')
        },
        {
            path: 'link-accounts',
            name: 'link-accounts',
            meta: {
                withAuth: true,
            },
            beforeEnter: () => {
                const authStore = getAuthenticationStore()
                if (!authStore || !authStore.isOwner) {
                    return { name: 'not-found' }
                }
            },
            component: () => view('offers/LinkAccountsView')
        },
    ]
}